import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ScheduleDirectory from "../../components/ScheduleDirectory/ScheduleDirectory";
import SaturnePage from "../../components/SaturnePage/SaturnePage";
import { SupportedActorType } from "../../services/fhir/fhir.types";

export default function SchedulesPage() {
  const navigate = useNavigate();
  const [actorType, setActorType] = useState<SupportedActorType>("patient");

  return (
    <SaturnePage loading={false} needsLogin wide>
      <ScheduleDirectory
        actorType={actorType}
        serverUrl={process.env.REACT_APP_FHIR_URL ?? "fhir"}
        onActorTypeChange={setActorType}
        onActorOpen={(type, actorId) =>
          navigate(`/Actors/${type}/${actorId}/Calendar`)
        }
        onError={() => navigate("/Error")}
      />
    </SaturnePage>
  );
}
